import { Trans, t } from '@lingui/macro'
import {
  Button,
  Grid,
  Icon,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  TableBody,
  TableHead,
  Typography,
  Divider,
  MenuItem
} from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { FieldArray, useFormikContext } from 'formik'
import React from 'react'
import { FormConnectToObject, getMuState } from '../Common'
import { getMainConnected } from '../../Form'
import { CurrencyFormat, CurrencyFormated } from 'app/views/common/Formats'
import { useDispatch, useSelector } from 'react-redux'
import { myI18n } from 'translation/I18nConnectedProvider'
import { endEditingField } from '../../multiuser/grpcMultiuserEdit'
import MUTextField from '../multiuser-input/MUTextField'

export const formOtherGrantsDefaultValue = (obj, info, item) => {
  const { connectedField } = getMainConnected(item)
  const field = connectedField?.name
  if (!field || !obj || !obj[field]) {
    return []
  }
  return obj[field].split(';;;').map(i => {
    const grant = i.split(';')
    return { name: grant[0], value: grant[1], state: grant[2] }
  })
}

export const formOtherGrantsValueToText = v => {
  const toRet = (
    <div>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={5} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Name</Trans>
          </Typography>
        </Grid>
        <Grid item xs style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Value</Trans>
          </Typography>
        </Grid>
        <Grid item xs style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Grants: State</Trans>
          </Typography>
        </Grid>
      </Grid>
      {v.map((grant, index) => {
        return (
          <>
            <div style={{ height: 8 }} />
            <Grid container key={index} style={{ width: '100%' }}>
              <Grid item xs={5} style={{ padding: 4 }}>
                <Typography>{grant.name}</Typography>
              </Grid>
              <Grid item xs style={{ padding: 4 }}>
                <Typography>
                  <CurrencyFormated value={grant.value} />
                </Typography>
              </Grid>
              <Grid item xs style={{ padding: 4 }}>
                <Typography>
                  <Trans id={grant.state} />
                </Typography>
              </Grid>
            </Grid>
          </>
        )
      })}
    </div>
  )
  return {
    en: toRet,
    fr: toRet
  }
}

export const formOtherGrantsExtractSaveKey = ({
  saveMap,
  item,
  sfObject,
  value,
  connectedProps,
  subObjectsMap,
  connectedObjectId
}) => {
  const { connectedField, connectedObject } = connectedProps
  const fieldName = connectedField?.name
  if (fieldName && connectedObject) {
    saveMap[connectedObject][fieldName] = value
      .map(i => `${i.name};${i.value};${i.state}`)
      .join(';;;')
  }
}

export const FormOtherGrantsPrint = ({ title, value = [] }) => {
  return (
    <div style={{ width: '100%' }}>
      <div className='form-print-title-small'>{title}</div>
      <Grid container style={{ width: '100%' }}>
        <Grid item xs={5} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Name</Trans>
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Value</Trans>
          </Typography>
        </Grid>
        <Grid item xs={3} style={{ padding: 4 }}>
          <Typography className='form-print-subtitle'>
            <Trans>Grants: State</Trans>
          </Typography>
        </Grid>
      </Grid>
      {value.map((grant, index) => {
        return (
          <>
            <Divider />
            <Grid container key={index} style={{ width: '100%' }}>
              <Grid item xs={5} style={{ padding: 4 }}>
                <Typography>{grant.name}</Typography>
              </Grid>
              <Grid item xs={4} style={{ padding: 4 }}>
                <Typography>
                  <CurrencyFormated value={grant.value} />
                </Typography>
              </Grid>
              <Grid item xs={3} style={{ padding: 4 }}>
                <Typography>
                  <Trans id={grant.state} />
                </Typography>
              </Grid>
            </Grid>
          </>
        )
      })}
    </div>
  )
}

export const FormOtherGrants = ({
  id,
  value,
  useMultiuser,
  formId,
  disabled,
  title,
  tooltip,
  typeProps,
  ...props
}) => {
  const user = useSelector(state => state.user)
  const { values, setFieldValue } = useFormikContext()
  const { isEdited, userColor, userName } = getMuState({ values, id })
  const { connectedTo = [] } = typeProps
  const columns = [t`Name`, t`Value`, t`Status`, t`Delete`]

  if (connectedTo.length === 0) {
    return (
      <div style={{ color: 'red' }}>
        <b>
          <Trans>Grants field was not connected in form editor!</Trans>
        </b>
      </div>
    )
  }

  const grants = value || []
  return (
    <FieldArray
      name={id}
      render={arrayHelpers => (
        <Grid
          container
          spacing={1}
          style={{ marginBottom: 5 }}
          justify='space-between'
        >
          <Grid item xs={12} style={{ marginTop: 25 }}>
            <div
              style={{
                marginBottom: -15,
                marginLeft: 20
              }}
            >
              {title}
              {tooltip && (
                <Tooltip title={tooltip}>
                  <IconButton aria-label='delete' size='small'>
                    <HelpOutlineIcon fontSize='inherit' />
                  </IconButton>
                </Tooltip>
              )}
              {!disabled && (
                <Button
                  variant='contained'
                  color='primary'
                  type='button'
                  disabled={disabled}
                  style={{ marginLeft: 5 }}
                  onClick={() => {
                    arrayHelpers.push({
                      name: '',
                      value: 0,
                      state: ''
                    })
                    if (useMultiuser) {
                      endEditingField({
                        userId: user.userId,
                        formId,
                        fieldId: id,
                        fieldValue: [
                          ...value,
                          {
                            name: '',
                            value: 0,
                            state: ''
                          }
                        ]
                      })
                    }
                  }}
                >
                  <Icon color='inherit'>add</Icon>
                  <span>
                    <Trans>Add Grant</Trans>
                  </span>
                </Button>
              )}
            </div>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} style={{ marginTop: 15 }}>
              <Table
                style={{ whiteSpace: 'pre', minWidth: 650 }}
                size='small'
                aria-label='a dense table'
              >
                <colgroup>
                  <col width='30%' />
                  <col width='30%' />
                  <col width='30%' />
                  <col width='10%' />
                </colgroup>
                <TableHead>
                  <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                    {columns.map((item, i) => (
                      <TableCell key={i} style={{ paddingLeft: 35 }}>
                        <p
                          style={{
                            textShadow: '2px 2px 0px rgba(63,107,169, 0.15)',
                            fontWeight: 'bold',
                            textAlign: 'center'
                          }}
                        >
                          <Trans id={item} style={{ marginRight: 10 }} />
                        </p>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {grants.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ paddingTop: 15 }}>
                        <MUTextField
                          useMultiuser={useMultiuser}
                          formId={formId}
                          id={id + `[${index}].name`}
                          label={myI18n._(t`Grant's Name`)}
                          disabled={disabled}
                        />
                      </TableCell>
                      <TableCell style={{ paddingTop: 15 }}>
                        <MUTextField
                          useMultiuser={useMultiuser}
                          formId={formId}
                          id={id + `[${index}].value`}
                          label={myI18n._(t`Grant's Value`)}
                          type='number'
                          disabled={disabled}
                          InputProps={{ inputComponent: CurrencyFormat }}
                          color='primary'
                        />
                      </TableCell>
                      <TableCell style={{ paddingTop: 15 }}>
                        <MUTextField
                          select
                          formId={formId}
                          useMultiuser={useMultiuser}
                          id={id + `[${index}].state`}
                          label={myI18n._(t`Grant's Status`)}
                          disabled={disabled}
                        >
                          {[
                            {
                              label: <Trans>Approved</Trans>,
                              value: 'en_ApprovedUS'
                            },
                            {
                              label: myI18n._('Pending'),
                              value: 'Pending'
                            },
                            {
                              label: myI18n._('Not submitted yet'),
                              value: 'Not submitted yet'
                            },
                            {
                              label: myI18n._('Declined'),
                              value: 'Declined'
                            }
                          ].map(item => (
                            <MenuItem value={item.value} key={item.key}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </MUTextField>
                      </TableCell>
                      <TableCell style={{ paddingTop: 15 }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {!disabled && (
                            <IconButton
                              variant='filled'
                              onClick={() => {
                                arrayHelpers.remove(index)
                                const newValue = [...value]
                                newValue.splice(index, 1)
                                if (useMultiuser) {
                                  endEditingField({
                                    userId: user.userId,
                                    formId,
                                    fieldId: id,
                                    fieldValue: newValue
                                  })
                                }
                              }}
                              disabled={disabled}
                            >
                              <Icon
                                color='error'
                                className='material-icons MuiIcon-root MuiIcon-colorError'
                                variant='filled'
                              >
                                delete
                              </Icon>
                            </IconButton>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}
    />
  )
}

export const FormEditorOtherGrants = ({
  editMode,
  showPrintProps,
  typeProps,
  depth,
  ...props
}) => {
  const { printPageBreakBefore } = typeProps
  const dispatch = useDispatch()
  if (!editMode) {
    return <FormOtherGrants typeProps={typeProps} {...props} />
  }

  return (
    <>
      <FormConnectToObject
        typeProps={typeProps}
        depth={depth}
        validTypes={['textarea', 'string']}
      />
    </>
  )
}
